import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PortalModalComponent } from './portal-modal.component';

// Base class for concrete portal modals (mirrors ui-modal-base). Grabs the child
// <portal-modal> and forwards its close through the subclass's own `close` output,
// so parents just bind (close)="…". Subclasses implement open(data).
@Component({ template: '' })
export abstract class PortalModalBaseComponent implements AfterViewInit {

	@ViewChild(PortalModalComponent) modal!: PortalModalComponent;

	// eslint-disable-next-line @angular-eslint/no-output-native
	@Output() close = new EventEmitter<any>();

	ngAfterViewInit(): void {
		this.modal.onClose = this.close;
	}

	abstract open(data: any): void;
}
